export const COLUMNS = [
  {
    Header: "Invoice Id",
    Footer: "Invoice Id",
    accessor: "invoice_id"
  },
  {
    Header: "Customer Name",
    Footer: "Customer Name",
    accessor: "customer_name"
  },
  {
    Header: "Status",
    Footer: "Status",
    accessor: "status"
  }
];
